"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var hooks_1 = require("../form/hooks");
var inputWrapper_1 = require("../inputWrapper");
exports.Captcha = function (_a) {
    var siteKey = _a.siteKey, id = _a.id, name = _a.name, onSuccess = _a.onSuccess, onExpire = _a.onExpire, _b = _a.languageCode, languageCode = _b === void 0 ? 'en' : _b;
    var _c = hooks_1.useForm(undefined, name, undefined, ''), value = _c[0], setValue = _c[1], _type = _c[2], _message = _c[3];
    var onloadCallbackName = "__captchaHandler_" + id + "_onload";
    var successCallbackName = "__captchaHandler_" + id + "_success";
    var expiredCallbackName = "__captchaHandler_" + id + "_expired";
    React.useEffect(function () {
        window[onloadCallbackName] = _onLoad;
        window[successCallbackName] = _onSuccess;
        window[expiredCallbackName] = _onExpire;
        var script = document.createElement('script');
        script.src = "https://www.google.com/recaptcha/api.js?onload=" + onloadCallbackName + "&render=explicit&hl=" + languageCode;
        document.head.appendChild(script);
    }, []);
    var _onLoad = function () {
        // @ts-ignore
        grecaptcha.render(id, {
            sitekey: siteKey,
            callback: successCallbackName,
            'expired-callback': expiredCallbackName,
        });
    };
    var _onSuccess = function (token) {
        setValue(token);
        if (typeof onSuccess === 'function') {
            onSuccess(token);
        }
    };
    var _onExpire = function () {
        setValue(undefined);
        if (typeof onExpire === 'function') {
            onExpire();
        }
    };
    return (React.createElement(inputWrapper_1.InputWrapper, { type: _type, message: _message },
        React.createElement("div", { id: id })));
};
